import { BorderColor, Delete } from '@mui/icons-material';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';
import { PermissionData } from '../../context/Component/PermissionData';

function Tables({
  setOpenEdit,
  deleteAreaOrganizacional,
  rowsColumn = [],
  areasOrganizacionalesCount,
  page,
  handleChangePage,
  rowsPerPage,
  handleChangeRowsPerPage,
}) {
  // * PERMISOS DEL USUARIO.
  const permisosState = PermissionData();

  const deleteArea = (data) => {
    deleteAreaOrganizacional(data);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell className="fw-bold" align="left">
                #
              </TableCell>
              <TableCell className="fw-bold" align="left">
                Área Organizacional
              </TableCell>
              <TableCell className="fw-bold" align="center">
                Cantidad Empleados
              </TableCell>
              <TableCell className="fw-bold" align="center" width="10%">
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rowsColumn.length > 0 ? (
              rowsColumn.map((row, index) => (
                <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    {index + 1}
                  </TableCell>
                  <TableCell sx={{ color: !row.activo && 'red' }} component="th" scope="row">
                    {row.nombre.replaceAll('-', '. ')}
                  </TableCell>
                  <TableCell align="center" component="th" scope="row">
                    {row.cantidadEmpleados}
                  </TableCell>

                  <TableCell component="th" scope="row">
                    <div className="d-flex justify-content-between">
                      {row.activo ? (
                        <>
                          <IconButton
                            className="text-primary-mem"
                            hidden={!permisosState.ROLE_EDITAR_AREAS_ORGANIZACIONALES}
                            onClick={() => setOpenEdit({ open: true, area: row })}
                          >
                            <BorderColor />
                          </IconButton>

                          {row.cantidadEmpleados === 0 && (
                            <IconButton
                              className="text-danger"
                              hidden={!permisosState.ROLE_BORRAR_AREAS_ORGANIZACIONALES}
                              onClick={() => deleteArea(row)}
                            >
                              <Delete />
                            </IconButton>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableCell colSpan={4} align="center">
                No hay registros
              </TableCell>
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={areasOrganizacionalesCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </>
  );
}

export default Tables;
